import {
  Box,
  Button,
  Group,
  LoadingOverlay,
  Modal,
  TextInput,
} from "@mantine/core";
import { useState } from "react";
import {
  sendLinkedinInvitation,
  sendLinkedinMessage,
} from "../../../../../../api/WorkflowAPI";
import { notifications } from "@mantine/notifications";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import LinkedinAccountSelector from "../../../../../../components/Selectors/LinkedinAccountSelector";
import { IconShare3 } from "@tabler/icons-react";
import LinkedinAnswerEditorMobile from "./LinkedinAnswerEditorMobile";

const AnswerSenderLinkedinMobile = ({
  prospect,
  item,
  about,
  setProspectLoading,
  isInvitation,
  defaultSender = null,
  lastLinkedinReply,
  alreadyOpened,
  title,
  handleClose,
}) => {
  const lang = useLanguage((s) => s.language);
  const [sender, setSender] = useState(
    item?.reply_to?.integration_id
      ? { id: item?.reply_to?.integration_id, is_valid: true }
      : defaultSender
  );
  const [recipient, setRecipient] = useState(about?.linkedin_url || "");
  const [loading, setLoading] = useState(false);
  const [answering, setAnswering] = useState(false);

  const [initialized, setInitialized] = useState(false);

  const handleInit = () => {
    setInitialized(true);
  };

  const handleSubmit = ({ text }) => {
    let newMessage = text;

    setLoading(true);

    const main = isInvitation ? sendLinkedinInvitation : sendLinkedinMessage;
    main({
      contact_id: prospect.id,
      integration_id: sender?.id,
      message: newMessage,
    })
      .then((res) => {
        notifications.show({
          message: isInvitation
            ? lang.leads.invitation_sent
            : lang.leads.message_sent,
          color: "green.8",
        });
        setAnswering(false);

        setProspectLoading(true);
      })
      .finally(() => setLoading(false));
  };

  const onClose = () => { 
    setAnswering(false)
    handleClose?.()
  }
  

  return (
    <>
      {!alreadyOpened && (
        <Button
          leftSection={<IconShare3 />}
          mx={8}
          mb={8}
          onClick={() => setAnswering(true)}
        >
          {lang.prm.answer}
        </Button>
      )}

      <Modal
        opened={alreadyOpened || answering}
        title={title}
        onClose={handleClose}
        size={"100%"}
      >
        <LoadingOverlay visible={loading || !initialized} />

        <LinkedinAccountSelector
          label={lang.leads.account}
          size={"sm"}
          mb={8}
          required
          onChange={setSender}
          value={sender?.id}
          withPool={false}
        />

        <TextInput
          type="url"
          value={recipient}
          mb={8}
          onChange={(e) => setRecipient(e.target.value)}
          label={lang.leads.contact_linkedin}
          placeholder={"https://www.linkedin.com/in/"}
          w={"100%"}
          required
          error={
            recipient !== about.linkedin_url ? lang.leads.linkedin_diff : null
          }
        />

        <LinkedinAnswerEditorMobile
          key={item?.id}
          id={item?.id}
          handleSubmit={handleSubmit}
          handleClose={onClose}
          onInit={handleInit}
          loading={loading}
          disabled={!sender || !recipient || recipient?.length < 10}
          isInvitation={isInvitation}
          lastLinkedinReply={lastLinkedinReply}
        />
      </Modal>
    </>
  );
};

export default AnswerSenderLinkedinMobile;
